import { RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.vendors.root,
    element: loadable(() => import('./pages/VendorsPage')),
  },
  {
    path: paths.vendors.tab,
    element: loadable(() => import('./pages/VendorsPage')),
  },
];
